export default __webpack_public_path__ + "static/logo-liberti-6e8ef5216fd9cc61f53b85509941bc99.svg";